import request from "./http";
import util from "./util";

// 公众号二维码
export function wechatQrcode(data) {
  return request({
    url: "wechat/qrcode",
    method: "get",
    params: util.json2formData(data)
  });
}

//UrlLink
export function getMiniUrlLink(data) {
  return request({
    url: "wechat/getMiniUrlLink",
    method: "get",
    params: util.json2formData(data)
  });
}

//UrlLink
export function getUrlLinkByCode(data) {
  return request({
    url: "wechat/getUrlLinkByCode",
    method: "get",
    timeout: 15000,
    params: util.json2formData(data)
  });
}

// 扫描轮询
export function pollingBind(data) {
  return request({
    url: "qrcodelogin",
    method: "post",
    params: util.json2formData(data)
  });
}

// 刷新token
export function refresh(data) {
  return request({
    url: "my/refresh",
    method: "get",
    params: util.json2formData(data)
  });
}


// 小程序二维码
export function xcxQrcode(data) {
  return request({
    url: "wechat/miniprogramqrcode",
    method: "get",
    params: util.json2formData(data),
    responseType: "blob"
  });
}

// 获取个人信息
export function userInfo(){
  return request({
    readOnly: true,
    url:"my/info",
    method:"get"
  })
}

// 获取全部信息
export function userallInfo(){
  return request({
    readOnly: true,
    url:"my/userinfo",
    method:"get"
  })
}

// 获取用户身份
export function identity(){
  return request({
    readOnly: true,
    url:"my/identity",
    method:"get"
  })
}

// 获取项目列表
export function works(data) {
  return request({
    readOnly: true,
    url: "deliver/works",
    method: "get",
    params: util.json2formData(data)
  });
}






// 获取客户行业
export function customerIndustries() {
  return request({
    url: "PhotographerWorkCustomerIndustries",
    method: "get"
  });
}


// 获取作品类型
export function workCategories() {
  return request({
    url: "photographerWorkCategories",
    method: "get"
  });
}

// 上传图片，获取七牛的参数
let uploadGrant = null
export function qiniuGetParams() {
  const identity = window.localStorage.getItem('access_token') || ''
  if (uploadGrant && uploadGrant.identity === identity && uploadGrant.expires > Date.now()) return uploadGrant.promise
  const entry = { identity, expires: Date.now() + 5 * 60 * 1000 }
  entry.promise = request({ url: 'qiniu/getParams', method: 'get', readOnly: true }).then(response => {
    if (!response || !response.data || !response.data.data || !response.data.data.upToken) throw new Error('upload_parameters_missing')
    return response
  }).catch(error => { if (uploadGrant === entry) uploadGrant = null; throw error })
  uploadGrant = entry
  return entry.promise
}


// 创建项目
export function createPro(data) {
  console.log(data)
  return request({
    url: "deliver/works",
    method: "POST",
    data:data
  });
}

// 进入项目详情
export function getDetails(data){
  return request({
    readOnly: true,
    url:'deliver/works/'+ data,
    method: "get"
  })
}

// 删除项目
export function deleteDetails(data){
  return request({
    url:'deliver/works/'+ data,
    method: "delete"
  })
}

// 进入下级目录
export function filelist(params) {
   return request({
    readOnly: true,
     url:'deliver/works/filelist',
     method:'get',
     params:params
   })
}

// 判断百度授权
export function isOauth(params) {
  return request({
    readOnly: true,
    url:'baidu/isOauth',
    method:'get',
    params:params
  })
}

// 提取码
let deliveryHandoff = null
let deliveryHandoffTimer
export function obtain(params, options = {}) {
  const identity = window.localStorage.getItem('access_token') || ''
  const previous = deliveryHandoff
  deliveryHandoff = null
  clearTimeout(deliveryHandoffTimer)
  if (!options.handoff && previous && previous.identity === identity && previous.code === params.code && previous.expires > Date.now()) {
    return Promise.resolve(previous.response)
  }
  return request({ url: 'deliver/works/obtain', method: 'post', data: params, readOnly: true }).then(response => {
    if (options.handoff && response && response.status === 200 && Array.isArray(response.data.data) && response.data.data.length) {
      deliveryHandoff = { identity, code: params.code, response, expires: Date.now() + 15000 }
      clearTimeout(deliveryHandoffTimer)
      deliveryHandoffTimer = setTimeout(() => { deliveryHandoff = null }, 15000)
    }
    return response
  })
}

// 下载次数
export function downUp(params){
  return request({
    url:'delivery/works/obtaintolocal',
    method:'POST',
    data:params
  })
}

// 获取个人信息
export function downloadAllImg(){
  return request({
    url:"my/downloadAllImg",
    method:"get"
  })
}

// -----------------------超爽整理工具---------------------

// 添加项目图片
export function addPhotographerWorkSource(params) {
  return request({
    url:'my/addPhotographerWorkSource',
    method:'post',
    data:params
  })
}

// 添加信息
export function addPhotographerWork(params) {
  return request({
    url:'my/addPhotographerWork',
    method:'post',
    data:params
  })
}

// 验证非法字符
export function wordcheck(params){
  // Production still exposes GET; the newer backend supports both methods.
  return request({
    url:'/wordcheck',
    method:"get",
    params
  })
}

// 消息推送
export function sendPhotographerWorkInfo(params){
  return request({
    url:'my/sendPhotographerWorkInfo',
    method:"post",
    params:params
  })
}


// 公众号二维码
export function wxJsAuth(data) {
  return request({
    url: "payment/wxJsAuth",
    method: "get",
    params: data
  });
}

// js支付
export function wxJsPay(data) {
  return request({
    url: "payment/wxJsPay",
    method: "post",
    params: data
  });
}

// h5支付
export function wxH5Pay(data) {
  return request({
    url: "payment/wxH5Pay",
    method: "post",
    params: data
  });
}

// 二维码支付
export function wxQrCodePay(data) {
  return request({
    url: "payment/wxQrCodePay",
    method: "post",
    params: data
  });
}



// 帮助明细
export function getHelpNotes(data) {
  return request({
    readOnly: true,
    url: "getHelpNotes_n",
    method: "get",
    params: data
  });
}

// 帮助明细
export function getHelpNoteDetail(data) {
  return request({
    readOnly: true,
    url: "sys/getHelpNoteDetail",
    method: "get",
    params: data
  });
}

//密钥登录
export function secretLogin(data) {
  return request({
    url: "secretLogin",
    method: "post",
    params: data
  });
}

// 摄影师信息
export function grapherinfo(data) {
  return request({
    url: "photographer/info", //获取摄影师的信息
    method: 'get',
    params: data
  });
}


//计算支付金额
export function calcOrderAmt(data) {
  return request({
    readOnly: true,
    url: "payment/calcOrderAmt", 
    method: 'post',
    params: data
  });
}
/*
// 活动
export function checkActiveSetting(data) {
  return request({
    url: "payment/checkActiveSetting",
    method: "get",
    params: data
  });
}
*/
// 折扣
export function getActiveDiscount(data) {
  return request({
    readOnly: true,
    url: "payment/getActiveDiscount",
    method: "get",
    params: data
  });
}

